<ul *ngFor="let video of videos">
    <li>
        <h2>{{ video.text.fullLabel }}</h2>
        <!-- <video width="600" controls>
            <source src="/assets/videos/{{video.url}}" type="video/mp4">
            Your browser does not support HTML5 video.
        </video> -->
        <!-- <iframe width="600" [src]="video.url"> </iframe> -->
        <a mat-button [href]="video.url" target="_blank" rel="noopener noreferrer">
            {{ 'help.tutorial.video.shortLabel' | translate }}
            <mat-icon>open_in_new</mat-icon>
        </a>
    </li>
</ul>
